import { PhotosSection } from "./sections/PhotosSection";
import SignaturesSection from "../../../../components/data/workorder/signature/SignaturesSection";

//TODO : FIx les types
export function Files({ data, canEdit = true }: { data: any, canEdit?: boolean }) {
  return (
    <div className="p-4">
      <PhotosSection workorderId={data.id} initialPhotos={data.photos} canEdit={canEdit} />
      <SignaturesSection workorderId={data.id} initialSignatures={data.signatures} contacts={(data.contacts || []).map((contact: any) => contact.contact)} canEdit={canEdit} />
    </div>
  );
}